import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-general-improvements",
  "use": "icon-general-improvements-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-general-improvements\"><rect width=\"24\" height=\"24\" fill=\"#ECF3FC\" rx=\"6\" /><path stroke=\"#2073F9\" stroke-linecap=\"round\" stroke-width=\"1.4\" d=\"M8.667 9h6M8.667 12.667h6M18 12V8.333a2.667 2.667 0 0 0-2.667-2.666H8a2.667 2.667 0 0 0-2.667 2.666v7.333A2.667 2.667 0 0 0 8 18.334h3.315M14 16.667l1.667 1.666L19 15\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol